import { Reveal } from './Reveal';

const CERTS = [
    {
        img: '/certificados/aumento-de-masa-muscular.jpg',
        pdf: '/certificados/aumento-de-masa-muscular.pdf',
        label: 'Aumento de masa muscular — 60 hs',
    },
    {
        img: '/certificados/programacion-de-entrenamiento-para-mujeres.jpg',
        pdf: '/certificados/programacion-de-entrenamiento-para-mujeres.pdf',
        label: 'Programación de entrenamiento para mujeres — 18 hs',
    },
    {
        img: '/certificados/entrenamiento-de-gluteo-y-abdomen.jpg',
        pdf: '/certificados/entrenamiento-de-gluteo-y-abdomen.pdf',
        label: 'Entrenamiento de glúteo y abdomen — 10 hs',
    },
];

export const Certificaciones = () => (
    <section id="certificaciones" className="py-24 px-6 bg-ink2 text-paper" data-testid="certificaciones-section">
        <div className="max-w-[1280px] mx-auto">
            <Reveal className="max-w-[560px] mb-14">
                <p className="text-roselight text-sm uppercase tracking-[0.12em] font-medium mb-4"><span className="text-xs align-middle">✦</span>&nbsp; Formación</p>
                <h2 className="font-serif font-normal text-[clamp(1.9rem,4vw,2.6rem)]" data-testid="certificaciones-title">
                    Mis certificaciones.
                </h2>
            </Reveal>
            <div className="grid grid-cols-3 gap-3 md:gap-5" data-testid="certificaciones-grid">
                {CERTS.map((c, i) => (
                    <Reveal key={i} delay={i * 0.08}>
                        <div
                            data-testid={`certification-item-${i + 1}`}
                            className="bg-paper/[0.04] border border-paper/[0.14] rounded-2xl overflow-hidden group"
                        >
                            <div className="aspect-[3/4] bg-paper/[0.06]">
                                <img
                                    src={c.img}
                                    alt={c.label}
                                    className="w-full h-full object-contain group-hover:scale-[1.03] transition duration-500"
                                />
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
